import React, { useState, useEffect } from 'react';
import Container from 'react-bootstrap/Container';
import Button from 'react-bootstrap/Button';
import Sidebar from './Sidebar';
import PageTitle from './PageTitle';
import Footer from './Footer';
import { LayoutProps } from '../../types';
import { Menu, X } from 'lucide-react';

const Layout: React.FC<LayoutProps> = ({ children, onLogout }) => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkScreenSize = () => {
      const mobile = window.innerWidth <= 768;
      setIsMobile(mobile);
      if (mobile) {
        setSidebarCollapsed(true);
      } else {
        setSidebarCollapsed(false);
      }
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);

    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  const toggleSidebar = () => {
    setSidebarCollapsed(!sidebarCollapsed);
  };

  return (
    <div className="d-flex vh-100" style={{ position: 'relative' }}>
      {/* Overlay para mobile */}
      {isMobile && !sidebarCollapsed && (
        <div 
          className="sidebar-overlay"
          onClick={() => setSidebarCollapsed(true)}
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            zIndex: 999,
          }}
        />
      )}

      <Sidebar 
        collapsed={sidebarCollapsed}
        isMobile={isMobile}
        onClose={() => setSidebarCollapsed(true)}
      />
      
      <div 
        className="flex-grow-1 d-flex flex-column"
        style={{
          marginLeft: isMobile ? '0' : '220px' // Compensar o espaço da sidebar fixa no desktop
        }}
      >
        {/* Botão hambúrguer para mobile */}
        {isMobile && (
          <div className="mobile-header d-flex align-items-center justify-content-between p-3 bg-white shadow-sm">
            <Button
              variant="outline-secondary"
              onClick={toggleSidebar}
              className="d-flex align-items-center justify-content-center"
              style={{
                width: '40px',
                height: '40px',
                borderRadius: '8px',
                border: '1px solid #dee2e6'
              }}
            >
              {sidebarCollapsed ? <Menu size={20} /> : <X size={20} />}
            </Button>
            <h5 className="mb-0 text-dark fw-bold">SystemLoc</h5>
            <div style={{ width: '40px' }}></div> {/* Espaçador */}
          </div>
        )}
        
        <PageTitle />
        <main className={`flex-grow-1 ${isMobile ? 'p-3' : 'p-4'}`}>
          <Container fluid>
            {children}
          </Container>
        </main>
        
        <Footer />
      </div>
    </div>
  );
};

export default Layout;
